import {gql} from 'apollo-angular';
export const GET_QUEST_ACTIVE = gql`
  query getQuestActive {
    getQuestActive {
      id
      questTitle
      descriptionText
      iconNumber
      remainingTime
      trophyPoints
      questTasks {
        id
        taskTitle
        taskDescription
        links {
          linkName
          linkValue
          linkType
        }
        targetGroup
        questTaskType
        iconNumber
        taskPoints
      }
    }
  }
`;
